import {ArrowUp} from "lucide-react";
import {useTranslation} from "react-i18next";

import {Button} from "@/components/ui/button";
import {cn} from "@/lib/utils";
import {ITEMS_PER_PAGE} from "@/src/modules/core/utils/constants";

type ListInfiniteEndBlockProps = {
  totalRecords: number;
  className?: string;
  messageClassName?: string;
};

/** End-of-infinite-list message + optional back-to-top (when list exceeds one page). */
export function ListInfiniteEndBlock({
  totalRecords,
  className,
  messageClassName,
}: ListInfiniteEndBlockProps) {
  const {t} = useTranslation("common");

  return (
    <div className={cn("flex flex-col items-center gap-2", className)}>
      <span className={cn("text-sm text-muted-foreground", messageClassName)}>
        {t("infinite.end_of_list", {defaultValue: "You've seen all records"})}
      </span>
      {totalRecords > ITEMS_PER_PAGE ? (
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            const el = document.querySelector("[data-scroll-container]");
            (el ?? window).scrollTo({top: 0, behavior: "smooth"});
          }}
        >
          <ArrowUp className="size-4" />
          {t("infinite.back_to_top", {defaultValue: "Back to top"})}
        </Button>
      ) : null}
    </div>
  );
}
